import { getToken } from '../../Utils/authUtils';
import { createAsyncThunk } from '@reduxjs/toolkit';
import { USERS } from '../../constant';

/**
 * Sonographers of the logged-in clinic — the list behind the report body's
 * "Sonographer:" picker. Role-exact on the backend, the same way
 * `getCardiologists` is: this names who performed the scan, so it must not
 * quietly include admins or receptionists.
 */
export const getSonographers = createAsyncThunk(
  'getSonographers',
  async (_payload: void, { rejectWithValue }) => {
    try {
      const token = getToken();
      const response = await fetch(USERS.GET_SONOGRAPHERS, {
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
          Authorization: `Bearer ${token}`,
        },
      });

      if (!response.ok) {
        const errorData = await response.json();
        return rejectWithValue(errorData.msg || 'Failed to fetch sonographers');
      }

      return await response.json();
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);
